import { marked } from "marked"

marked.use({
  breaks: true,
  mangle: false,
  useNewRenderer: true,
  renderer: {
    link(token) {
      const text = this.parser.parseInline(token.tokens)

      return token.href.startsWith(`/`)
        ? `<a href="${token.href}">${text}</a>`
        : `<a href="${token.href}" target="_blank" rel="noreferrer noopener">${text}</a>`
    },
  },
})

const markdown = (text) => {
  if (typeof text !== `string`) return ``

  text = text.replace(/#(?!#|\s)/gm, `# `) // e.g. "##Heading" -> "## Heading"

  // text = text.replace(
  //   /\[(https?:\/\/[^)]+)\]\((?!https?:\/\/)([^)]+)\)/g,
  //   `[$2]($1)`
  // ) // e.g. [https://link.com](text) -> [text](https://link.com)

  // text = text.replace(/\[[^)]+\]\(\)/g, ``) // e.g. [https://link.com]() -> ``

  // text = text.replace(/\[(mailto:[^)]+)\]\(([^)]+)\)/g, `[$2]($1)`) // e.g. [mailto:email@email.com](text) -> [text](mailto:email@email.com)

  return marked.parse(text)
}

export default markdown
